import { MapPin, Phone, Clock, Navigation, MessageCircle, BadgeCheck } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Reveal, SectionHead } from "./Reveal";

const Row = ({ icon: Icon, title, children }) => (
  <div className="flex gap-4">
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-maroon-tint text-maroon"><Icon className="h-5 w-5" /></span>
    <div><p className="font-semibold text-ink">{title}</p><div className="mt-0.5 text-[15px] text-muted2">{children}</div></div>
  </div>
);

export const ContactBlock = () => (
  <section id="contact" data-testid="contact-section" className="py-20 md:py-28">
    <div className="container-x grid gap-12 lg:grid-cols-2">
      <div>
        <SectionHead eyebrow="संपर्क · Visit Us" title="बलिया में हमसे मिलें" />
        <Reveal delay={0.1} className="mt-10 space-y-6">
          <Row icon={MapPin} title="मुख्य अस्पताल"><span data-testid="contact-address">{CONTACT.addressHi}</span><p className="font-en text-xs">{CONTACT.addressEn}</p></Row>
          <Row icon={MapPin} title="रसड़ा केंद्र"><span data-testid="contact-address-2">{CONTACT.address2Hi}</span><p className="font-en text-xs">{CONTACT.address2En}</p></Row>
          <Row icon={Phone} title="फ़ोन / WhatsApp"><a href={`tel:${CONTACT.phoneDial}`} data-testid="contact-phone" className="font-en hover:text-maroon">{CONTACT.phoneDisplay}</a></Row>
          <Row icon={Clock} title="समय"><p>{CONTACT.timingsHi}</p><p>{CONTACT.sundayHi}</p></Row>
          <p className="flex items-center gap-2 rounded-2xl bg-amber-50 p-4 font-semibold text-amber-800"><BadgeCheck className="h-5 w-5" /> {CONTACT.freeCheckupHi}</p>
          <div className="flex flex-wrap gap-3">
            <a href={CONTACT.mapDirections} target="_blank" rel="noreferrer" data-testid="contact-directions-button" className="btn btn-maroon"><Navigation className="h-4 w-4" /> रास्ता देखें</a>
            <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-button" className="btn btn-wa"><MessageCircle className="h-4 w-4" /> WhatsApp</a>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.15}>
        <iframe title="Medicity Hospital map" data-testid="contact-map" src={CONTACT.mapEmbed} loading="lazy" className="h-[420px] w-full rounded-[28px] border-0 lg:h-full lg:min-h-[520px]" />
      </Reveal>
    </div>
  </section>
);
